import { createStore, applyMiddleware, compose } from 'redux';
import rootReducer from './reducers';
import thunk from 'redux-thunk';
import { loadState, saveState } from './localStorage';

let finalCreateStore = null;
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

if (import.meta.env.VITE_APP_STAGE !== 'Prod')
    finalCreateStore = composeEnhancers(
        applyMiddleware(thunk),
        //applyMiddleware(createLogger())
    )(createStore);
else finalCreateStore = compose(applyMiddleware(thunk))(createStore);

export default function configureStore() {
    const persistedState = loadState();

    // ColorCard data is fetched when the page mounts. Restoring this slice can
    // revive transient state such as isSubmitting without its running request.
    if (persistedState) delete persistedState.colorCard;

    const store = finalCreateStore(rootReducer, persistedState);

    store.subscribe(() => {
        let state = store.getState();

        saveState({
            jobs: state.jobs,
            printers: state.printers,
            flowOrders: state.flowOrders,
            pairingInfo: state.pairingInfo,
            permissionsInfo: state.permissionsInfo,
            filters: state.filters,
        });
    });

    return store;
}
